import React, { FC, useRef } from "react";
import { ChatServerButton, ChatServerList, ChatServerListItem } from "../../xapp/ChatServerMessage";
import { ListItem } from "../ListItem";
import "./List.scss";
import { OpenUrlCallback } from "../../hooks/useOpenUrlCallback";

export interface ListProps {
    readonly list: ChatServerList;
    /**
     * A callback that is called when a button on the list item was clicked.
     */
    onButtonClick(button: ChatServerButton): void;
    /**
     * Returns the text of the list item that was clicked and optional token.
     *
     * @param text - Text of the list item that was clicked.
     * @param token - Optional, token that was passed with the list item.
     */
    onExecute(text: string, token?: string): void;
    /**
     * Opens the URL in the browser.
     */
    onOpenUrl: OpenUrlCallback;
}

const List: FC<ListProps> = (props) => {
    const { list } = props;

    const listRef = useRef<HTMLDivElement>(null);

    const hasImage = list.items.some((item) => item.imageUrl);

    const titlesOnly = !list.items.some((item) => item.subTitle || item.buttons?.length);

    const listItems = list.items.map((item: ChatServerListItem, itemIndex: number) => {
        return (
            <div className="xappw-vlist-container__item" key={`item-key-${itemIndex}`}>
                <ListItem
                    item={item}
                    layout={titlesOnly ? "titles" : "normal"}
                    emptyImageVisible={hasImage}
                    onExecute={props.onExecute}
                    onButtonClick={props.onButtonClick}
                    onOpenUrl={props.onOpenUrl}
                />
            </div>
        );
    });

    return (
        <div className="xappw-vlist">
            <div ref={listRef} className="xappw-vlist-container">
                {props.list.title && <div className="xappw-vlist__header">{props.list.title}</div>}
                {listItems}
            </div>
        </div>
    );
};

export default List;
